module.exports = __webpack_public_path__ + "static/luidy-642be2882f7ccbd21cfd154ee0ae0ba2.jpg";